import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { fbqPageView } from "@/lib/analytics";

/**
 * Scroll to top on route change, or to hash section if present.
 * Also fires Meta Pixel PageView on every SPA route change (the initial script
 * only fires once — SPAs need to re-fire on client-side navigation).
 */
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Meta Pixel: track every client-side page view (initial + subsequent)
    fbqPageView();

    if (hash) {
      const id = hash.replace("#", "");
      // Delay to allow route content to mount
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname, hash]);

  return null;
}
